import * as types from '../types';
import moment from 'moment';
import update from 'immutability-helper';
import {
    ONBOARDING_STATUS_PENDING_ID,
} from '@Utils/constants'


export const initialAddForm = {

    onboardingTrainingID: '',
    trainingMasterModuleID: 0,
    companyId: 0,
    trainingCategory: 0,
    trainingName: '',
    facilitator: 0,
    startTrainingDate: moment().format('MM/DD/YYYY HH:mm'),
    endTrainingDate: moment().format('MM/DD/YYYY HH:mm'),
    onboardingType: 0,
    onboardingStatus: ONBOARDING_STATUS_PENDING_ID,
    createDate: moment().format('MM/DD/YYYY HH:mm'),
    createdBy: 0,
    participantIDs: [],
}


const defaultState = {
    loading: false,
    addForm: { ...initialAddForm },
    holidayDates: [],
    emailTemplate: { subject: '', body: '' },
    alert: {
        show: false,
        title: 'Create success',
        content: 'Successfuly created record.',
        confirmLabel: 'Ok',
        goBackToListFlag: false,
    },
    addParticipants: {
        shows: false,
        title: 'Create success',
        content: 'Successfuly created record.',
        confirmLabel: 'Ok',
    }
}



export default function addReducer(state = defaultState, action) {
    switch (action.type) {
        case types.CHG_FIELD:
        case types.CHG_STATUS:
            return update(state, {
                addForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            });
        case types.RESET_ADD_DATA:
            return update(state, {
                addForm: { $set: initialAddForm },
                alert: { $set: defaultState.alert }
            });
        case types.UPD_ADD_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.UPD_ADD_MEMO_CHAR_COUNT:
            return update(state, {
                addForm: {
                    memoCharCount: { $set: state.addForm.memoCharCount - 1 }
                }
            });
        case types.INSERT_LOADING:
            return update(state, {
                loading: { $set: action.payload }
            })
        case types.HIDE_ADD_ALERT:
            return update(state, {
                alert: {
                    show: { $set: false }
                },
                addParticipants: { shows: { $set: false } }
            })
        case types.ADD_RECORD:
            return update(state, {
                records: [...state.records, action.payload]
            });
        case types.ADD_PARTICIPANTS:
            return update(state, {
                addParticipants: { $set: action.payload }
            });
        case types.SET_HOLIDAY_DATES:
            return update(state, {
                holidayDates: { $set: action.payload.holidayDates }
            });
        case types.SET_ADD_EMAIL_TEMPLATE:
            return update(state, {
                emailTemplate: { $set: action.payload }
            });
        default:
            return state;
    }
}
